import React from 'react';
import type { FC } from 'react';
import logoPath from "./BullRedLogo.svg"

interface BullRedLogoProps {
  [key: string]: any;
}

const BullRedLogo: FC<BullRedLogoProps> = (props) => (
  <img
    alt="BullRed Logo"
    src={logoPath}
    height={100}
    width={200}
    style={{
      margin: 1
    }}
    {...props}
  />
);

export default BullRedLogo;